import { createRoot, Root } from "react-dom/client";
import InfoPopup, { InfoPopupProps, OrderLocation } from "./InfoPopup";

// Each routed marker owns its popup and cleans it up with its map overlays.
export function attachRouteOrderPopup(marker: google.maps.Marker, map: google.maps.Map, group: OrderLocation[],
  actions: Pick<InfoPopupProps, "onSetEndpoint" | "onReverseRoute" | "onRemoveFromRoute" | "removeDisabled">) {
  let popup: google.maps.InfoWindow | undefined, root: Root | undefined;
  let selectedId = String(group[0]?.orderId ?? "");
  const close = () => popup?.close();
  const render = () => root?.render(<InfoPopup group={group} selectedId={selectedId} onSelect={id => { selectedId = id; render(); }} onClose={close}
    onSetEndpoint={actions.onSetEndpoint ? async (id, end) => { await actions.onSetEndpoint!(id, end); close(); } : undefined}
    onReverseRoute={actions.onReverseRoute ? async () => { await actions.onReverseRoute!(); close(); } : undefined}
    removeDisabled={actions.removeDisabled}
    onRemoveFromRoute={actions.onRemoveFromRoute ? async id => { await actions.onRemoveFromRoute!(id); close(); } : undefined} />);
  const listener = marker.addListener("click", () => {
    if (!group.length) return;
    if (!popup) { const host = document.createElement("div"); popup = new google.maps.InfoWindow({ content: host }); root = createRoot(host); }
    render(); popup.open({ anchor: marker, map, shouldFocus: false });
  });
  return () => { listener?.remove?.(); close(); const oldRoot = root; window.setTimeout(() => oldRoot?.unmount(), 0); root = undefined; };
}
